export const getClientType = () => {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return 'IOS';
    }
    if (/(Android)/i.test(navigator.userAgent)) {
        return 'ANDROID';
    }
    return 'PC';
};
